<section class="option" [class.closed]="closed">
  <dgx-components-icon [name]="icon"></dgx-components-icon>
  <p class="description">{{ description }}</p>
</section>
